<template>
  <div style="padding:20px;">
    <h2>Google Address Test</h2>
    <place-autocomplete placeholder="Type address here"></place-autocomplete>
  </div>
</template>

<script>
export default {
  name: "GoogleAddressTest"
}
</script>